import React    from 'react';
import { Link } from 'react-router-dom';

import './scss/style.scss';

import needReset      from '../../../../../../common/tools/need-reset';
import { useCatalog } from '../../../../../../providers/catalog';

function FooterNavigationItem({
  label,
  urlKey,
}) {
  const {
          getCatalogItems,
          resetFilter,
        } = useCatalog();

  return (
    <li>
      {urlKey.match(/^https?:\/\//) ? (
        <a
          href={urlKey}
          target={'_blank'}
          rel={'noreferrer noopener'}
        >{label}</a>
      ) : (
        <Link
          onClick={() => {
            if (needReset(urlKey)) {
              resetFilter();
              getCatalogItems(urlKey);
            }
          }}
          to={urlKey}
        >{label}</Link>
      )}
    </li>
  );
}

export default FooterNavigationItem;